export default {
	home: {
		afunOriginals: "AFun Originals",
		slots: "Slots",
		liveCasino: "Live Casino",
		casualGames: "Casual Games",
		newReleases: "Bagong Labas",
		casinoTitle: "Casino",
		casinoDesc: "Tamasahin ang mga laro sa casino na may libu-libong slots, live dealers, at table games",
		goToCasino: "Pumunta sa Casino",
		sportsTitle: "Sports",
		sportsDesc: "Tumaya sa Football, Basketball, Tennis at iba pang sports na may pinakamahusay na odds",
		goToSports: "Pumunta sa Sports",
		liveTitle: "Live",
		liveDesc: "Real-time na aksyon kasama ang live dealers at interactive gaming experience",
		goToLive: "Pumunta sa Live",
		latestBetRace: "Pinakabagong Taya at Karera",
		sports: "Sports",
		latestBets: "Pinakabagong Taya",
		game: "Laro",
		player: "Manlalaro",
		bet: "Taya",
		multiplier: "Multiplier",
		profit: "Kita",
		top10Games: "Top 10 na Laro",
		vip: "VIP",
		rewards: "Mga Gantimpala",
		affiliate: "Kasosyo",
		promotion: "Promosyon"
	},

	latestBetRace: {
		title: "Grand Prix ng Game Leaderboard",
		playerBetRank: "Mga Taya ng Player Ngayong Araw",
		playerWinRank: "Mga Panalo ng Player Ngayong Araw",
		gameBetRank: "Mga Taya sa Game Ngayong Araw",
		gameWinRank: "Mga Return sa Game Ngayong Araw",
		player: "Player",
		game: "Game",
		bet: "Taya",
		profit: "Panalo",
		ratio: "Rasio ng Payout",
		totalBet: "Kabuuan ng Taya",
		totalReturn: "Kabuuan ng Return",
		maxBet: "Max na Taya",
		gameRatio: "% ng Return",
		noData: "Walang Data",
	},

	GameClassify: {
		casinoTitle: "Casino",
		casinoDesc: "Masiyahan sa mga laro sa casino mula sa mga nangungunang provider",
		casinoBtn: "Pumunta sa Casino",
		sportsTitle: "Sports",
		sportsDesc: "Tumaya sa Football, Cricket, NFL, eSports at higit sa 80 sports",
		sportsBtn: "Pumunta sa Sports",
		liveTitle: "Live",
		liveDesc: "Real-time na aksyon kasama ang mga live dealer",
		liveBtn: "Pumunta sa Live"
	}
}